export enum PromoCodeTypeEnum {
  PERCENTAGE = 'PERCENTAGE',
  AMOUNT = 'AMOUNT'
}

export const promoCodeTypeMapping: Record<
  PromoCodeTypeEnum,
  { label: string; symbol: '€' | '%' }
> = {
  [PromoCodeTypeEnum.PERCENTAGE]: {
    label: 'Pourcentage',
    symbol: '%'
  },
  [PromoCodeTypeEnum.AMOUNT]: {
    label: 'Montant',
    symbol: '€'
  }
}
